module.exports = __webpack_public_path__ + "static/media/promotionResumptionPackageUnder30.5d30238b.webp";